var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div style=\"width: 450px\"><h4>Header Text</h4><div class=\"list-group b-t-0 m-b-0 no-margin-bottom no-border-top\"><a ng-repeat=\"pl in $ctrl.pricelists\" class=\"list-group-item\" ng-click=\"$ctrl.setPriceList(pl)\"><div class=\"row\"><div class=\"col-sm-10 col-xs-9\"><h4>{{pl.priceListId}}</h4><p>Some option text</p></div></div></a></div></div>";
var id1="cart-pricelist-dropdown-menu.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;